import { ref } from 'vue'

export default () => ({
  watchlists: ref([]),
  currentWatchlist: ref(null),
  unreadTotal: ref(0)
})
